import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { AdminApp } from './apps/AdminApp';
import { MerchantApp } from './apps/MerchantApp';
import { TrackApp } from './apps/TrackApp';
import { SignupPage } from './features/auth/SignupPage';
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { VerifyEmailPage } from './features/auth/VerifyEmailPage';
import { detectAppFromHost } from './utils/appHost';

/**
 * Single Vite build deployed to multiple subdomains.
 * Routes to the correct app based on `window.location.hostname` — see `utils/appHost`.
 */
export default function App() {
  const app = useMemo(detectAppFromHost, []);
  const loc = useLocation();

  // /forgot-password and /reset-password are public on any host
  if (loc.pathname === '/forgot-password' || loc.pathname.startsWith('/forgot-password/')) {
    return (<Routes><Route path="/forgot-password/*" element={<ForgotPasswordPage />} /></Routes>);
  }
  if (loc.pathname === '/reset-password' || loc.pathname.startsWith('/reset-password/')) {
    return (<Routes><Route path="/reset-password/*" element={<ResetPasswordPage />} /></Routes>);
  }
  // The verification link is mailed to merchants and clicked from an inbox on any device — it must
  // resolve on whichever host they land on, exactly like the password-reset links above.
  if (loc.pathname === '/verify-email' || loc.pathname.startsWith('/verify-email/')) {
    return (<Routes><Route path="/verify-email/*" element={<VerifyEmailPage />} /></Routes>);
  }

  // /signup is a public page on any host — short-circuit hostname routing for it
  if (loc.pathname === '/signup' || loc.pathname.startsWith('/signup/')) {
    return (
      <Routes>
        <Route path="/signup/*" element={<SignupPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {app === 'admin' && <Route path="/*" element={<AdminApp />} />}
      {app === 'merchant' && <Route path="/*" element={<MerchantApp />} />}
      {app === 'track' && <Route path="/*" element={<TrackApp />} />}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

